import { Api } from '@monorepo/shared/apiClient';
import { useMutation } from 'react-query';

export function useSetLastViewedDashboard() {
  return useMutation(Api.updateLastViewedDashboard);
}
